if (!customElements.get('new-media-gallery')) {
    customElements.define(
      'new-media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="Slider-Gallery"]'),
            thumbnails: this.querySelector('[id^="Slider-Thumbnails"]'),
          };
          this.initSlider();
          this.mql = window.matchMedia('(min-width: 901px)');
          if (!this.elements.thumbnails) return;
          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
          const silderheight = this.elements.viewer.clientHeight;
          this.elements.thumbnails.style.width = `${silderheight}px`;
        }

        initSlider() {
          const viewer = this.elements.viewer
          const thumbnails = this.elements.thumbnails
          const options = JSON.parse(viewer.getAttribute('data-option'));
          const thumOptions = JSON.parse(thumbnails.getAttribute('data-option'));
          const flkty = new Flickity( viewer, options);
          const thumFlkty = new Flickity( thumbnails, thumOptions);
          setTimeout(() => {
            flkty.resize()
            thumFlkty.resize()
          }, 200);
          window.addEventListener('resize', function() {
            flkty.resize();
            const silderheight = viewer.clientHeight;
            thumbnails.style.width = `${silderheight}px`;
            thumFlkty.resize()
          }, true);
        }
  
        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector('.product__modal-opener--image img');
          if (!image) return;
          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };
          image.src = image.src;
        }
  
        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
  
        removeListSemantic() {
          if (!this.elements.viewer) return;
          this.elements.viewer.setAttribute('role', 'presentation');
          this.elements.viewer.querySelectorAll('.slider__slide').forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    );
  }
  